import { useState } from "react"
import { GetApp } from "../../App"
import { Block, BlockField, BlockRow } from "../../Components/Block"
import { LocalizedMessage } from "../../Components/LocalizedMessage"
import { subscriptionRendersInApp } from "../../App/IAP"
import { AppRoutes, GetAppView } from "../AppView"
import { FocusViewData } from "./Context"
import { FocusSubscriptionWarningViewProps } from "./Params"

// The trial/subscription warning shown between today and tomorrow in the focus tree.
// Owns its own "dismissed today" state (equivalent to the parent-held state it replaced):
// dismissing hides it until the current day changes.
export function FocusSubscriptionWarningView({ currentState }: FocusSubscriptionWarningViewProps) {
  const app = GetApp()!;
  const t = app.getT("FocusView");
  const { subscriptionExpired, navigateApp } = GetAppView();
  const [warningDismissedDay, setWarningDismissedDay] = useState<number | undefined>(undefined);

  if (!app.account || !currentState) {
    return null;
  }

  const accountStatus = currentState.subscriptionStatus;
  const accountSubscriptionExpired = FocusViewData.accountSubscriptionExpired(accountStatus, subscriptionExpired);

  // Check if warning was already dismissed today
  const currentDay = currentState.day;
  if (warningDismissedDay === currentDay) {
    return null;
  }

  const warningKey = FocusViewData.subscriptionWarningKey(accountStatus, app.account.nextBillingAt, new Date(), accountSubscriptionExpired);
  if (!warningKey) {
    return null;
  }
  const messageKey = warningKey === "sevenDays"
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: replace `any` with a concrete type
    ? (m: any) => m.subscription["7Days"]
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: replace `any` with a concrete type
    : (m: any) => m.subscription[warningKey];

  const dismissWarning = () => {
    setWarningDismissedDay(currentDay);
  };

  // The subscription/plan view renders in-app for cloud and native iOS (so the
  // StoreKit purchase can run); only a non-iOS native app opens it on the server.
  const viewPlans = () => {
    dismissWarning();
    if (subscriptionRendersInApp(app)) {
      navigateApp(AppRoutes.accountSubscription);
    } else {
      app.openServer("account/subscription");
    }
  };

  return (
    <Block className="subscription-warning">
      <BlockRow className="block-row-followed-by-block-row">
        <BlockField>
          <LocalizedMessage message={messageKey} />
        </BlockField>
      </BlockRow>
      <BlockRow actions={true} className="block-row-last">
        <BlockField><button className="button" onClick={dismissWarning}>{t("close")}</button></BlockField>
        <BlockField><button className="button default" onClick={viewPlans}>{t("view_plans")}</button></BlockField>
      </BlockRow>
    </Block>
  );
}
